import styled, { css } from 'react-emotion'
import { text, radii, colors, shadows, desktop } from './styleguide'

const primaryStyle = css`
  border-radius: ${radii.outer};
  font-size: ${text.paragraph};
  background-color: ${colors.primary};
  color: ${colors.background};
  border: 0;
  ${shadows.button};
  padding: 1rem 2rem;
  width: 100%;
  ${desktop(
    css`
      width: auto;
      padding: 1rem 4rem;
    `
  )} &:hover {
    background-color: ${colors.background};
    border-color: ${colors.background};
    color: ${colors.primary};
  }
`
export default styled.button`
  border-radius: ${radii.inner};
  background-color: ${colors.background};
  padding: 0.6rem 1.4rem;
  color: ${colors.secondary};
  font-family: Futura;
  margin: 0;
  font-size: ${text.subtext};
  transition: all 200ms ease;
  border: 2px solid ${colors.secondary};
  cursor: pointer;
  &:hover {
    background-color: ${colors.secondary};
    border-color: ${colors.secondary};
    color: ${colors.background};
  }
  ${props => props.primary && primaryStyle};
`



// WEBPACK FOOTER //
// ../styleguide/src/Button.jsx